import React from "react";
import PropTypes from "prop-types";

/**
 * Loading component for consistent loading state display across the app
 */
const Loading = ({ fullScreen = true }) => {
  if (fullScreen) {
    return (
      <div
        className="flex flex-col justify-center items-center min-h-screen bg-light-grey"
        data-testid="loading"
      >
        <LoadingContent />
      </div>
    );
  }

  return (
    <div
      className="flex flex-col justify-center items-center py-8"
      data-testid="loading"
    >
      <LoadingContent />
    </div>
  );
};

// Extracted inner content for reuse
const LoadingContent = () => (
  <div className="flex flex-col items-center justify-center">
    {/* Emblem container with fixed dimensions */}
    <div className="relative w-20 h-20 flex items-center justify-center overflow-hidden">
      {/* Static emblem */}
      <img
        src="/emblem-gold.png"
        alt="DayShift Sports Emblem"
        className="w-full h-full object-contain"
      />

      {/* Shimmer overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-shimmer"></div>
    </div>

    {/* Loading text - larger with ellipsis */}
    <div className="mt-4 text-lg md:text-xl text-dark-grey font-medium">
      Loading...
    </div>
  </div>
);

Loading.propTypes = {
  fullScreen: PropTypes.bool,
};

export default Loading;
